




























	import AbpBase from "@/lib/abpbase";
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
    import {GetExInfo,GetXueYaExList,GetDlyCompsList} from '../../../api/abnormal'
    import u from 'underscore'

	@Component({})
	export default class  extends AbpBase {
        @Watch('tabsValue')
        wtabsValue(val:any,oldVal:any){
            this.getData(val)
        }
		list:any = [
            
        ]
        tabsValue = '1'
        modelShow = false
        modelTitle = ''
        date = [new Date(new Date().setMonth(new Date().getMonth()-1)),new Date()]
        detailList =  [
            {
                name: 'John Brown',
                age: 18,
                address: 'New York No. 1 Lake Park'
            },
            {
                name: 'Jim Green',
                age: 25,
                address: 'London No. 1 Lake Park',
                cellClassName: {
                    k4: 'demo-table-info-cell-age',
                }
            },
            {
                name: 'Joe Black',
                age: 30,
                address: 'Sydney No. 1 Lake Park'
            },
            {
                name: 'Jon Snow',
                age: 26,
                address: 'Ottawa No. 2 Lake Park',
            }
        ]


		created(){
            this.getData(1)
        }
        renderColumns(){
            this.columns = [
                {
                    title:'患者姓名',
                    key:'patientName',
                    sortable: 'custom'
                },
                {
                    title:'异常日期',
                    key:'dialysisDate',
                    sortable: 'custom',
                    render:(h:any,params:any)=>{
                        return h('span',Array.from(new Set(params.row.date)).join('、') )
                    }
                },
                {
                    title:'操作',
                    width:80,
                    render: (h:any,params:any)=>{
                        return h('span',{
                            style:{
                                color:'#009688',
                                cursor:'pointer'
                            },
                            on:{
                                click:()=>{
                                    this.renderDetailColumns(this.tabsValue)
                                    this.detail(params.row)
                                    this.modelShow = true
                                }
                            }
                        },'详情')
                    }
                },
            ]
        }
        renderDetailColumns(type:any){
            console.log(type)
            if(type==2){
                this.detailColumns = [
                    {
                        title:'透析日期',
                        render:(h:any,params:any)=>{
                            return h('span',this.formatDate(params.row.creationTime) )
                        }
                    },
                    {
                        title:'并发症详情',
                        key:'content',
                    },
                    {
                        title:'记录人',
                        key:'creatorUser',
                    },
                ]
            }else if(type==1){
                let detailList =  this.detailList;
                let newArray = [];
                let vm = this;
                //根据组号分组
                let group_obj= u.groupBy(detailList,function(value:any, key:any, list:any){return vm.formatDate(list[key].dialysisDate)})
                let bp_i = 1;
                for (const key in group_obj) {
                    let obj:any = {
                        date:key,
                    }
                    group_obj[key].forEach((item:any)=>{
                        switch(item.xueYaType){
                            case 1:
                            obj.tqbp = item.sbp+'/'+item.dbp
                            break;
                            case 2:
                            obj.sjbp = item.sbp+'/'+item.dbp
                            break;
                            case 3:
                                if(obj['tzbp'+bp_i]){
                                    bp_i++;
                                    obj['tzbp'+bp_i] = item.sbp+'/'+item.dbp
                                }else{
                                    obj['tzbp'+bp_i] = item.sbp+'/'+item.dbp
                                }
                            break;
                            case 4:
                            obj.xjbp = item.sbp+'/'+item.dbp
                            break;
                            case 5:
                            obj.thbp = item.sbp+'/'+item.dbp
                            break;
                        }
                    })
                    newArray.push(obj)
                }
                this.detailList = newArray;
                console.log(newArray)
                this.detailColumns = [
                    {
                        title:'透析日期',
                        key:'date',
                    },
                    {
                        title:'透前血压',
                        key:'tqbp',
                    },
                    {
                        title:'上机血压',
                        key:'sjbp',
                    },
                ]
                for(var i = 1; i < bp_i;i++){
                    this.detailColumns.push({
                        title:'透中血压'+i,
                        key:'tzbp'+i,
                    })
                }
                this.detailColumns.push({
                    title:'下机血压',
                    key:'xjbp',
                })
                this.detailColumns.push({
                    title:'透后血压',
                    key:'thbp',
                })
            }else{
                this.detailColumns = [
                    {
                        title:'透析日期',
                        render:(h:any,params:any)=>{
                            return h('span',this.formatDate(params.row.dialysisDate) )
                        }
                    },
                    {
                        title:'干体重',
                        key:'dryWeight',
                    },
                    {
                        title:'IDWG',
                        key:'idwg',
                    },
                    {
                        title:'IDWG/干体重%',
                        render:(h:any,params:any)=>{
                            return h('span',parseInt((params.row.idwg/params.row.dryWeight)*100)+'%')
                        }
                    },
                ]
            }
                    
              
        }
        columns:any = []
        detailColumns:any = []
        sortChange(row:any){
            if(row.order == "desc"){
                this.getData(this.tabsValue,row.key == "patientName" ? 1:2)
            }else{
                this.getData(this.tabsValue)
            }
        }
        async getData(type:any,order:any = null){
            let data = {
                OrderType:order,
                ExType:type,
                StrDateTime:this.date?this.formatDate(this.date[0]):'',
                EndDateTime:this.date?this.formatDate(this.date[1]):'',
            }
            if(!order){
                delete data.OrderType
            }
            console.log(data)
            this.list = []

            let res;
            if(type==3){
                res = await GetExInfo(data)
                //根据组号分组
                let group_obj= u.groupBy(res,function(value:any, key:any, list:any){return list[key].patientName})
                for (const key in group_obj) {
                    const element = group_obj[key];
                    this.list.push({
                        date:element.map((v:any)=>{return this.formatDate(v.dialysisDate)}),
                        patientName:key,
                        items:element
                    })
                }
            }else if(type==1){
                res = await GetXueYaExList(data)
                //根据组号分组
                let group_obj= u.groupBy(res,function(value:any, key:any, list:any){return list[key].patientName})
                console.log(group_obj)
                for (const key in group_obj) {
                    const element = group_obj[key];
                    this.list.push({
                        date:element.map((v:any)=>{return this.formatDate(v.creationTime)}),
                        patientName:key,
                        items:element
                    })
                }
            }else if(type==2){
                res = await GetDlyCompsList(data)
                //根据组号分组
                let group_obj= u.groupBy(res.objects,function(value:any, key:any, list:any){return list[key].patientName})
                for (const key in group_obj) {
                    const element = group_obj[key];
                    this.list.push({
                        date:element.map((v:any)=>{return this.formatDate(v.creationTime)}),
                        patientName:key,
                        items:element
                    })
                }
            }
            // this.list = res
            
            console.log(this.list)
            this.renderColumns()
        }
        detail(row:any){
            if(this.tabsValue=='3'){
                this.modelTitle = `患者${row.patientName}体重异常详情`
            }
            if(this.tabsValue=='2'){
                this.modelTitle = `患者${row.patientName}并发症异常详情`
            }
            if(this.tabsValue=='1'){
                this.modelTitle = `患者${row.patientName}血压异常详情`
            }
            this.detailList = row.items
            console.log(row.items,2222222)
            this.renderDetailColumns(this.tabsValue)
        }

	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/abnormal/remind/index.vue